import { types } from "mobx-state-tree"

export const DoctorTitle = types
    .model({
        titleId: types.optional(types.number, 0),
        titleName: types.optional(types.string, "")
    }).actions(self => ({

    }))